import api from './api';

export default {
    async getInfoCompany(accessToken) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.get('/company', {
                method: 'GET',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados dos certificados:', error);
            throw error;
        }
    },
    async setInfoCompany(accessToken, payload) {
        try {
            const headers = {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            };
            const response = await api.put('/company', payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao criar novo dados da empresa:', error);
            throw error;
        }
    },
    async getVideoteca(accessToken) {
        const response = await api.get('/company/videoteca', {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        return response.data;
    },
    async linkVideotecaAccount(accessToken, payload) {
        const response = await api.put('/company/videoteca/account', payload, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
    async createVideotecaFolder(accessToken) {
        const response = await api.post('/company/videoteca/folder', {}, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
  
};
